<template>
  <div>
    <NuxtLayout name="resource" :item="item" />
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>
